import { TAvailabilityFullParams, TAvailabilityRates } from '@/domain/Availability.domain';
import { instanceTS } from '../Axios';
import { ApiUrls } from '@/service/constants/urls';

export const getAvailabilityFullByIds = (
    params: TAvailabilityFullParams
): Promise<TAvailabilityRates> => {
    return instanceTS
        .get<TAvailabilityRates>(ApiUrls.activity.availability.root, { params })
        .then(({ data }) => data);
};
